import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  FetchBusinessGeneralFailure,
  FetchBusinessGeneralRequest,
  FetchBusinessGeneralSuccess,
  FetchPropertyGeneralFailure,
  FetchPropertyGeneralRequest,
  FetchPropertyGeneralSuccess,
} from './dashboard.actions'
import { DashboardService } from './dashboard.service'
import * as DashboardTypes from './dashboard.types'

@Injectable()
export class DashboardEffects {
  constructor(
    private actions: Actions,
    private dashboardService: DashboardService,
    private router: Router,
  ) {}

  FetchPropertyGeneral$ = createEffect(() =>
    this.actions.pipe(
      ofType(DashboardTypes.FETCH_PROPERTY_GENERAL_REQUEST),
      switchMap((action: FetchPropertyGeneralRequest) => {
        return this.dashboardService.fetchPropertyGeneral().pipe(
          map((result) => {
            return new FetchPropertyGeneralSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPropertyGeneralFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchBusinessGeneral$ = createEffect(() =>
    this.actions.pipe(
      ofType(DashboardTypes.FETCH_BUSINESS_GENERAL_REQUEST),
      switchMap((action: FetchBusinessGeneralRequest) => {
        return this.dashboardService.fetchBusinessGeneral().pipe(
          map((result) => {
            return new FetchBusinessGeneralSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchBusinessGeneralFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
